var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"block h-100 w-100"},[_c('div',{staticClass:"flex align-center justify-center h-100"},[_c('span',{staticClass:"text-blue-400 cursor-pointer",on:{"click":_vm.onRedirectLogin}},[_vm._v(_vm._s(_vm.generateUrl))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }